import { Shield, Sun, Feather, Repeat, Heart, Sparkles } from "lucide-react";
import { FEATURES } from "../data/site";
import Reveal from "./Reveal";
import { Star } from "./Illustrations";
import { Spiral, Flower, Lightning } from "./Doodles";

const ICONS = {
  uv: Sun, polarized: Shield, lightweight: Feather, flexible: Repeat, safe: Heart, play: Sparkles,
};
const TONES = {
  uv: "#F4C734", polarized: "#A9CDE5", lightweight: "#8BC547",
  flexible: "#EE8C72", safe: "#C6B9D6", play: "#F0A8C3",
};

export default function WhySol() {
  return (
    <section className="relative py-24 md:py-36 px-5 md:px-10 bg-[#FAFAF7] overflow-hidden" data-testid="why-sol">
      <Spiral size={60} className="absolute top-16 right-[8%] hidden md:block" color="#DD2E20" />
      <Flower size={50} className="absolute top-24 left-[6%] wiggle hidden md:block" color="#F4C734" center="#8BC547" />
      <Lightning size={36} className="absolute bottom-12 right-[20%] wiggle hidden md:block" />
      <Star size={22} className="absolute bottom-1/3 left-[12%] wiggle" color="#A9CDE5" />

      <div className="relative mx-auto max-w-[1280px]">
        <Reveal>
          <p className="eyebrow mb-4">Why SOL</p>
        </Reveal>
        <Reveal delay={60}>
          <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl leading-[1.02] tracking-[-0.025em] max-w-[22ch]">
            <span className="italic" style={{ color: "#DD2E20" }}>Real</span> protection,<br />built for real childhoods.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {FEATURES.map((f, i) => {
            const Icon = ICONS[f.key];
            return (
              <Reveal key={f.key} delay={i * 70}>
                <div
                  className="rounded-[24px] p-6 md:p-8 h-full lift relative overflow-hidden"
                  style={{ background: TONES[f.key] }}
                  data-testid={`why-feature-${f.key}`}
                  data-hover="true"
                >
                  <div className="w-12 h-12 rounded-full bg-[#FAFAF7] flex items-center justify-center relative z-10">
                    <Icon className="w-5 h-5" strokeWidth={1.6} />
                  </div>
                  <h3 className="mt-6 font-serif text-2xl md:text-3xl tracking-tight relative z-10">{f.title}</h3>
                  <p className="mt-2 text-[#2C2C2A]/80 text-[15px] md:text-base relative z-10">{f.line}</p>
                  {/* mini doodle */}
                  <Star size={14} className="absolute top-4 right-5 wiggle" color="#2C2C2A" />
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
